import { RequestResponse } from "@/api/acendex/types";
import { getToken } from "@/utils/token-util";
import {
  FetchApiServiceFactory,
  type SignalFetchApiConfig,
} from "./fetch-signal";

const TOKEN_HEADER: string = "x-access-token";

export const apiService = FetchApiServiceFactory.create();

const configureRequest = (
  config: SignalFetchApiConfig
): SignalFetchApiConfig => {
  const token = getToken();
  let language = localStorage.getItem("i18n");
  let companyIdStr = localStorage.getItem("companyId");
  let userCode = localStorage.getItem("userCode");
  if (!language) {
    language = "en";
  }

  //language
  if (language) {
    if (config.method === "GET") {
      if (!config.params) {
        config.params = {};
      }
      config.params["language"] = language;
    }
    //post添加token
    if (config.method === "POST") {
      if (!config.data) {
        config.data = {};
      }
      config.data.language = language;
    }
  }
  //userCode
  if (userCode) {
    if (config.method === "GET") {
      if (!config.params) {
        config.params = {};
      }
      config.params["userCode"] = userCode;
    }
    //post添加token
    if (config.method === "POST") {
      if (!config.data) {
        config.data = {};
      }
      config.data.userCode = userCode;
    }
  }
  //companyIdStr
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers[TOKEN_HEADER] = token;
    //get添加token
    if (config.method === "GET") {
      if (!config.params) {
        config.params = {};
      }
      config.params["token"] = token;
    }
    //post添加token
    if (config.method === "POST") {
      if (!config.data) {
        config.data = {};
      }
      config.data.token = token;
    }
  }
  //公司id添加
  if (companyIdStr && companyIdStr != "" && companyIdStr != "undefined") {
    const companyId = parseInt(companyIdStr);
    //get添加companyId
    if (config.method === "GET") {
      if (!config.params) {
        config.params = {};
      }
      config.params["companyId"] = companyId;
    }
    //post添加companyId
    if (config.method === "POST") {
      if (!config.data) {
        config.data = {};
      }
      config.data.companyId = companyId;
    }
  }

  const hostname = window.location.hostname;
  const apiUrlMap = {
    localhost: "https://jiaoyiys.icu", //"http://127.0.0.1:1084",
    "206.238.199.169": "https://jiaoyiys.icu",
    "91.208.236.30": "https://jiaoyiys.icu",
  };
  const BASE_API_URL = apiUrlMap[hostname] ? apiUrlMap[hostname] : "";

  config.baseURL = BASE_API_URL || "";

  // if (config.method?.toUpperCase() == "POST") {
  //   if (config.data) {
  //     config.data.uid = uid;
  //     config.data.language = language;
  //     config.data.companyId = companyId;
  //     config.data.token = token;
  //   } else {
  //     config.data = {
  //       uid,
  //       language,
  //       companyId,
  //       token,
  //     };
  //   }
  // }
  // if (config.method?.toUpperCase() == "GET") {
  //   if (config.params) {
  //     config.params.uid = uid;
  //     config.params.language = language;
  //     config.params.companyId = companyId;
  //     config.params.token = token;
  //   } else {
  //     config.params = {
  //       uid,
  //       language,
  //       companyId,
  //       token,
  //     };
  //   }
  // }
  return config;
};

apiService.addRequestMiddleware(configureRequest);

apiService.addResponseMiddleware((response) => {
  const res = response as RequestResponse<any>;

  if (res.ok) {
    return res.data;
  }

  return response;
});
